module.exports = __webpack_public_path__ + "img/expovina-primavera_06.60dbea0a.jpg";